module.exports = __webpack_public_path__ + "img/icon-germany.182690f.svg";